var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003245_44265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 2.0625C13.4375 2.125 13.5625 2.25 13.5938 2.4375L14.2188 5.78125L17.5625 6.40625C17.75 6.4375 17.875 6.5625 17.9375 6.71875C18 6.875 18 7.0625 17.9062 7.1875L15.9375 10H14C14 7.8125 12.1875 6 10 6C7.78125 6 6 7.8125 6 10H4.03125L2.0625 7.1875C1.96875 7.0625 1.96875 6.875 2.03125 6.71875C2.09375 6.5625 2.21875 6.4375 2.40625 6.40625L5.78125 5.78125L6.375 2.4375C6.40625 2.25 6.53125 2.125 6.6875 2.0625C6.84375 2 7.03125 2 7.15625 2.09375L10 4.0625L12.8125 2.09375C12.9375 2 13.125 2 13.2812 2.0625ZM10 7C11.6562 7 13 8.34375 13 10H7C7 8.34375 8.34375 7 10 7ZM19.25 11C19.6562 11 20 11.3438 20 11.75C20 12.1875 19.6562 12.5 19.25 12.5H15.75C15.3125 12.5 15 12.1875 15 11.75C15 11.3438 15.3125 11 15.75 11H19.25ZM12.75 11C13.1562 11 13.5 11.3438 13.5 11.75C13.5 12.1875 13.1562 12.5 12.75 12.5H2.75C2.3125 12.5 2 12.1875 2 11.75C2 11.3438 2.3125 11 2.75 11H12.75ZM17.25 13.75C17.6562 13.75 18 14.0938 18 14.5C18 14.9375 17.6562 15.25 17.25 15.25H0.75C0.3125 15.25 0 14.9375 0 14.5C0 14.0938 0.3125 13.75 0.75 13.75H17.25ZM2 17.25C2 16.8438 2.3125 16.5 2.75 16.5H6.25C6.65625 16.5 7 16.8438 7 17.25C7 17.6875 6.65625 18 6.25 18H2.75C2.3125 18 2 17.6875 2 17.25ZM8.5 17.25C8.5 16.8438 8.8125 16.5 9.25 16.5H19.25C19.6562 16.5 20 16.8438 20 17.25C20 17.6875 19.6562 18 19.25 18H9.25C8.8125 18 8.5 17.6875 8.5 17.25Z",
    fill: "url(#paint0_linear_40003245_44265)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40003245_44265",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003245_44265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLove);
export default __webpack_public_path__ + "static/media/shareLove.11fe92737dc09a12c889eca3a7e1b777.svg";
export { ForwardRef as ReactComponent };